var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16,
    viewBox: "0 0 16.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M7.853,1.147,3.431-3.275A6.443,6.443,0,0,0,4.972-7.5a6.5,6.5,0,0,0-6.5-6.5A6.476,6.476,0,0,0-8-7.5,6.494,6.494,0,0,0-1.528-1,6.465,6.465,0,0,0,2.7-2.567L7.119,1.855A.63.63,0,0,0,7.5,2a.5.5,0,0,0,.353-.853ZM-1.5-2A5.49,5.49,0,0,1-7-7.5,5.49,5.49,0,0,1-1.5-13,5.472,5.472,0,0,1,4-7.5,5.49,5.49,0,0,1-1.5-2Z",
    transform: "translate(8 14)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.ce784f5f5a360b6d0173b05d99aca3ca.svg";
export { ForwardRef as ReactComponent };